"use client"

import { useEffect, useRef, useState } from "react";

export const useOutsideClick = ({ state, callBack }) => {
	const node = useRef();
	useEffect(() => {
		if (state) {
			document.addEventListener("mousedown", handleOutsideClick);
		} else {
			document.removeEventListener("mousedown", handleOutsideClick);
		}
		return () => {
			document.removeEventListener("mousedown", handleOutsideClick);
		};
	}, [state]);

	const handleOutsideClick = (e) => {
		if (node.current && node.current.contains(e.target)) {
			return;
		}
		callBack(false);
	};

	return [node];
};

export const fixTimestamp = (str) => {
	const months = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec",
	];
	const t = str.split("T")[0].split("-");
	return t[1] + " " + months[parseInt(t[1] - 1)] + ", " + t[0];
};

export const sleep = (m) => new Promise((r) => setTimeout(r, m));

/**
 * Extracts the last name from a surgeon name string for alphabetical sorting.
 * Strips credentials after the first comma, then takes the last word of the name.
 * e.g. "Kelly S. Dempsey, MD, FACS" → "dempsey"
 *      "John Abdelsayed, MD"        → "abdelsayed"
 *      "JOHN D. FISHER, MD, FACS"   → "fisher"
 */
export const getLastName = (fullName = "") => {
  const namePart = fullName.split(",")[0].trim(); // drop ", MD, FACS" etc.
  const parts = namePart.split(" ").filter(Boolean);
  let lastName = parts[parts.length - 1] || "";
  const suffixes = ["jr", "jr.", "sr", "sr.", "ii", "iii", "iv", "v"];
  if (suffixes.includes(lastName.toLowerCase()) && parts.length > 1) {
    lastName = parts[parts.length - 2];
  }
  return lastName.toLowerCase();
};

export const generateRandomString = (n) => {
	const characters =
		"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	let randomString = "";
	for (let i = 0; i < n; i++) {
		const randomIndex = Math.floor(Math.random() * characters.length);
		randomString += characters[randomIndex];
	}
	return randomString;
};

export const generateRandomSSN = () => {
	const firstPart = Math.floor(100 + Math.random() * 900);
	const secondPart = Math.floor(10 + Math.random() * 90);
	const thirdPart = Math.floor(1000 + Math.random() * 9000);
	const ssn = `${firstPart}-${secondPart}-${thirdPart}`;
	return ssn;
};

export const generateRandomPhoneNumber = (n) => {
	const min = Math.pow(10, n - 1);
	const max = Math.pow(10, n) - 1;
	return Math.floor(Math.random() * (max - min + 1)) + min;
};


const useIntersectionObserver = (options) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);
  
    useEffect(() => {
      const observer = new IntersectionObserver(([entry], observerInstance) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observerInstance.unobserve(entry.target); // Stop observing after first intersection
        }
      }, options);
  
      if (ref.current) {
        observer.observe(ref.current);
      }
  
      return () => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      };
    }, [options]);
  
    return [ref, isVisible];
  };
  
  export const AnimatedSection = ({ children, animation = "fadeInUp", delay="0.5s", speed = "slow", className = "" }) => {
	const [ref, isVisible] = useIntersectionObserver({ threshold: 0.2 });
  
	return (
	  <div
		ref={ref}
		className={`${className} ${isVisible ? `animate__animated animate__${animation} animate__${speed} animate__delay-${delay}` : "opacity-0"}`}
		style={{ transition: "opacity 0.5s ease-in-out", position: "relative", zIndex:"10" , width: "100%"}}
	  >
		{children}
	  </div>
	);
  };
  
  import React from "react";

  export const TextListFromNewline = ({ text }) => {
	if (!text) return null;
  
	const decodedText = text.replace(/\\n/g, '\n');

	const lines = decodedText
	  .split("\n")
	  .filter((line) => line.trim() !== "");
	// const lines = text
	//   .split("\n")
	//   .filter((line) => line.trim() !== "");
  
	return (
	  <ul style={{ listStyleType: "square", paddingLeft: "20px" }} >
		{lines.map((line, index) => (
		  <li style={{ listStyle: "square" }} key={index}>{line}</li>
		))}
	  </ul>
	);
  };

  


  